import classes from "./Layout.module.css";
import Header from "../Header";

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <main className={classes.main}>{children}</main>
    </>
  );
};

export default Layout;
